import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { AREAS, CONTACT } from "../../data/site";
import { Reveal, Kicker } from "./Reveal";

const MAP = "https://www.google.com/maps?q=Charlotte,North+Carolina&z=10&output=embed";

export const ServiceArea = () => (
  <section id="service-area" className="bg-white py-24 lg:py-32" data-testid="service-area">
    <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 lg:grid-cols-2 lg:px-10">
      <div>
        <Reveal><Kicker>Service Area</Kicker></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display mt-4 text-4xl font-extrabold sm:text-5xl lg:text-6xl">
            Proudly serving Charlotte & beyond.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 max-w-md text-ffc-gray">
            Based in {CONTACT.city}, we cover the greater metro and surrounding communities.
            Not sure if we reach you? Just ask.
          </p>
        </Reveal>
        <div className="mt-8 flex flex-wrap gap-3">
          {AREAS.map((a, i) => (
            <motion.span key={a} initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }} transition={{ delay: i * 0.04 }}
              className="inline-flex items-center gap-1.5 rounded-full border border-ffc-line bg-ffc-light px-4 py-2 text-sm font-semibold text-ffc-ink"
              data-testid={`area-${i}`}>
              <MapPin className="h-3.5 w-3.5 text-ffc-red" /> {a}
            </motion.span>
          ))}
          <span className="inline-flex items-center rounded-full bg-ffc-blue px-4 py-2 text-sm font-semibold text-white">
            + surrounding areas
          </span>
        </div>
      </div>
      <Reveal delay={0.1}>
        <div className="overflow-hidden rounded-2xl border border-ffc-line shadow-[0_20px_60px_-30px_rgba(13,59,142,0.5)]">
          <iframe title="Fast Fix Charlotte service area map" src={MAP} className="h-[420px] w-full" loading="lazy"
            referrerPolicy="no-referrer-when-downgrade" data-testid="service-map" />
        </div>
      </Reveal>
    </div>
  </section>
);
